
import React, {useEffect,useState} from "react";
import { useHistory,Link, useLocation  } from 'react-router-dom';
import { useWebViewStore } from "../webview/useWebViewStore";
import {useApplicationStore} from '../home/ApplicationStore';
import launchExternal from '../../util/launchExternal';
import { IUserIPRestrictionEntity } from '../dealer-admin/ip-access/IPRestrictionInterface';
import { useIPRestrictionStore } from "../dealer-admin/ip-access/IPRestrictionStore";
import { Button, withTooltip,THEMES, BUTTON_VARIANTS, BUTTON_SIZES} from 'cdk-radial';
import {useGlobalStore} from "../core/GlobalStore";
import * as Styles from './styles';
import { useTranslation } from "react-i18next";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import userProfileStore from "../core/UserProfileStore";
import { useAnalytics } from '../third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import useUserSettingStore from "../dashboard/UserSettingStore";
import { hasAnyDashboardAccess } from '../utils/dashboardAccessUtils';

const findIpRestricted = (ipRestriction:IUserIPRestrictionEntity[], appId:string) =>{
  const data = ipRestriction?.find(
    (item:IUserIPRestrictionEntity) => item.entityType === 'application' 
    && item.entityId === appId 
    
  );
  return data;
}

const NavItem = ({item,isActive,handleSelect}:any) =>{

  const Icon = item.icon;
  const extendedHeight = true;
  const { trackEvent } = useAnalytics();

  return (
    <RestrictionToolTip message={item.isRestricted ? item.restrictionMessage : ""}>
      <Styles.NavButton isActive={isActive} extendedHeight={extendedHeight} data-testid={`${item.key}-tab`}
        onClick={(e: any) => {
          handleSelect(e, item.key)
          trackEvent(AMPLITUDE_EVENTS.SELECT_LEFTNAVITEM, {
            'Item': item.key
          });
        }
        }
        style={{
          pointerEvents: item.isRestricted ? "none" : "auto",
          opacity: item.isRestricted ? 0.5 : 1,
        }}
      >
        <Styles.NavIconStack>
          {item.icon && <Icon />}
          <Styles.NavLabel>{item.label}</Styles.NavLabel>
        </Styles.NavIconStack>
      </Styles.NavButton>
      </RestrictionToolTip>
  )

};

const NavItemWithLink = ({item,isActive,handleAppSelect}:any) =>{
  const Icon = item.icon;
  const extendedHeight = item.key === 'cdkU' || item.key === 'resourceCenter' || item.key === 'customerCare';
  const { trackEvent } = useAnalytics();

  return (
    <RestrictionToolTip message={item.isRestricted ? item.restrictionMessage : ""}>
      <Link tabIndex={-1} to={item.isRestricted ? "#" : item.url} rel="noreferrer"
      style={{
        pointerEvents: item.isRestricted ? "none" : "auto",
        opacity: item.isRestricted ? 0.5 : 1,
        padding: '0px',
        margin: '0px',
        textDecoration: 'none',
        height: 'auto',
        background: 'inherit',
        transition: 'none'
      }}>
        <Styles.NavButton isActive={isActive} extendedHeight={extendedHeight}
          disabled={item.isRestricted}
          data-testid={`${item.key}-tab`}
          onClick={() => {handleAppSelect(item.key);
             trackEvent(AMPLITUDE_EVENTS.SELECT_LEFTNAVITEM, {
                    'Item': item.key
                });
              
          }}>
          <Styles.NavIconStack>
            <Icon />
            <Styles.NavLabel>{item.label}</Styles.NavLabel>
          </Styles.NavIconStack>
        </Styles.NavButton>
      </Link>
      </RestrictionToolTip>
  )

}


const getNavigationMenu = (t:any,
  applications:any,hasAivaPermission:boolean,ipRestriction:IUserIPRestrictionEntity[],
  hasDashboardPermission:boolean) =>{

  const app = applications?.find((app: any) => app.name === 'Document Management Platform')
  const dmp = findIpRestricted(ipRestriction,app?.id);
  const cdku = findIpRestricted(ipRestriction,"CDKU");
  const drc = findIpRestricted(ipRestriction,"DRC");
  const cc = findIpRestricted(ipRestriction,"CCPQA") || findIpRestricted(ipRestriction,"CCP");

  let NAV = [
    { key: "myUnify", label: t("nav.myUnify"), icon: MyUnifyIcon },
    { key: "applications", label: t("nav.apps"), icon: AppsIcon },
    { key: "workflows", label: t("nav.workflows"), icon: WorkflowIcon },
    { key: "dashboards", label: t("nav.dashboards"), icon: DashboardIcon },
    { key: "docs", label: t("nav.documents"), icon: DocumentIcon , url: `/unify/aview/${app?.id}/N` ,
      isRestricted: dmp?.isRestricted, restrictionMessage:dmp?.message },
    { key: "aiva", label: "AIVA", icon: AivaIcon },
    { key: "cdkU", label: "CDK University", icon: CdkUIcon, url:"/unify/aview/CDKU/N" ,
      isRestricted: cdku?.isRestricted, restrictionMessage:cdku?.message 
    },
    { key: "resourceCenter", label: "Resource Center", icon: ResourceCenterIcon, url:"/unify/aview/DRC/N" ,
      isRestricted: drc?.isRestricted, restrictionMessage:drc?.message
    },
    { key: "customerCare", label: "Customer Care", icon: CustomerCareIcon,
      isRestricted: cc?.isRestricted, restrictionMessage:cc?.message 
     },
  ] as any;

  if(!app){
    NAV = NAV.filter((item:any) => item.key !== "docs");
  }
  if(!hasAivaPermission){
    NAV = NAV.filter((item:any) => item.key !== "aiva");
  }
  if(!hasDashboardPermission){
    NAV = NAV.filter((item:any) => item.key !== "dashboards");
  }
  return NAV;

}

const RestrictionToolTip = ({id,message,children}:any) => {
  const tooltipProps = {
    id: id,
    text: message,
    theme: THEMES.LIGHT
  };
  /* eslint-disable react/prop-types */
  const ComponentToRender = (props:any) => {
  return (
    <div
      {...props}
    >
      {children}
    </div>
  );
};
  const ComponentWithTooltip = message ? withTooltip(ComponentToRender, tooltipProps) : ComponentToRender;
  return <ComponentWithTooltip />
}

export default function Navigation() {
  const history = useHistory();
  const location = useLocation();
  const { aivaAccess,roles,unifyUserProfile} = userProfileStore();
  const { resetActive  } = useWebViewStore();
  const { applications } = useApplicationStore();
  const [active, setActive] = React.useState('');
  const UNIFY_UI_AIVA_FLAG = useFeatureFlag("UNIFY_UI_AIVA");
  const ipRestriction = useIPRestrictionStore((state:any) => state.ipRestriction);
  const [menu,setMenu] = useState([]);
  const {isNavBarCollapsed,setAivaOpen} = useGlobalStore() ;
  const { t } = useTranslation();
  const {dashboardAccessSetting,exemptedUsers} = useUserSettingStore();
  const hasDashboardPermission = hasAnyDashboardAccess(roles, unifyUserProfile?.loginId, exemptedUsers, dashboardAccessSetting);
  const [expandCollapse, setExpandCollapse] = useState(false);

  useEffect(()=>{
    const menu = getNavigationMenu(
      t,
      applications,
      UNIFY_UI_AIVA_FLAG && aivaAccess,
      ipRestriction,
      hasDashboardPermission);
    setMenu(menu);
  },[t,applications,aivaAccess,ipRestriction,hasDashboardPermission, UNIFY_UI_AIVA_FLAG])


  useEffect(()=>{
    if(location.pathname === '/unify/applications'){
       setActive("applications")
       setExpandCollapse(false)
    }
    else if(location.pathname === '/unify/workflows'){
        setActive("workflows")
        setExpandCollapse(false)
    }
    else if(location.pathname === '/unify/myUnify'){
      setActive("myUnify")
      setExpandCollapse(false)
    }
    else if(location.pathname === '/unify/dashboards'){
      setActive("dashboards")
      setExpandCollapse(false)
    }else{
      setExpandCollapse(true)
    }

  },[location])

  

  const handleSelect = (e:any,key: string) => {
    e.stopPropagation();
    setActive(key);
    if(key === 'aiva'){
      setAivaOpen(true);
    }
    else if(key === 'customerCare'){
      const app = applications?.find((app: any) => app.id === 'CCPQA' ||  app.id === 'CCP');
      launchExternal(app.url);
    }else if(key === 'productUpdate'){
      handleProductLink();
    }else{
      resetActive();
      history.push(`/unify/${key}`);
    }
  };

  const handleAppSelect = (key: string) => {
    setActive(key);
    resetActive();
    if(key === 'docs'){
      const app = applications?.find((app: any) => app.name === 'Document Management Platform');
      history.push(`/unify/aview/${app.id}/N`);
    }else if(key === 'cdkU'){
      history.push(`/unify/aview/CDKU/N`);
    }else if(key === 'resourceCenter'){
      history.push(`/unify/aview/DRC/N`);
    }
  }

  const handleProductLink = () => {
    window.open('https://www.cdkglobal.com/product-updates','_blank','noopener,noreferrer');
  }

  return (
    <Styles.NavContainer>
      <Styles.Aside isCollapsed={isNavBarCollapsed && expandCollapse} aria-label="Primary navigation">
        <Styles.NavWrap isCollapsed={isNavBarCollapsed && expandCollapse} aria-hidden={isNavBarCollapsed}>
          <Styles.NavList>
            {menu?.map((item:any) => {
              const isActive = active === item.key;
              return (
                <li key={item.key}>
                  {item.url &&
                    <NavItemWithLink item={item} isActive={isActive} handleAppSelect={handleAppSelect}></NavItemWithLink>
                }
                {!item.url && 
                   <NavItem item={item} isActive={isActive} handleSelect={handleSelect}></NavItem>
                }
                </li>
              );
            })}
          </Styles.NavList>
        </Styles.NavWrap>
      </Styles.Aside>
      <Styles.ProductButton isCollapsed={isNavBarCollapsed && expandCollapse} aria-hidden={isNavBarCollapsed && expandCollapse}>
        <Button disabled={isNavBarCollapsed && expandCollapse} text={'Product\nUpdates'} variant={BUTTON_VARIANTS.TEXT} size={BUTTON_SIZES.SMALL}
          onClick={handleProductLink}>
        </Button>
      </Styles.ProductButton>
    </Styles.NavContainer>
  );
}

function DocumentIcon(){
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" >
    <path fillRule="evenodd" clipRule="evenodd" d="M8.4 3H3.6C2.72 3 2.008 3.7875 2.008 4.75L2 15.25C2 16.2125 2.72 17 3.6 17H16.4C17.28 17 18 16.2125 18 15.25V6.5C18 5.5375 17.28 4.75 16.4 4.75H10L8.4 3Z" fill="currentColor"/>
    </svg>
  )
}

function MyUnifyIcon(){
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" >
    <g clipPath="url(#clip0_6084_34)">
    <path d="M2.5 3.7C2.5 3.03726 3.03726 2.5 3.7 2.5H8.3C8.96274 2.5 9.5 3.03726 9.5 3.7V8.3C9.5 8.96274 8.96274 9.5 8.3 9.5H3.7C3.03726 9.5 2.5 8.96274 2.5 8.3V3.7Z" fill="currentColor"/>
    <path d="M2.5 11.7C2.5 11.0373 3.03726 10.5 3.7 10.5H16.3C16.9627 10.5 17.5 11.0373 17.5 11.7V16.3C17.5 16.9627 16.9627 17.5 16.3 17.5H3.7C3.03726 17.5 2.5 16.9627 2.5 16.3V11.7Z" fill="currentColor"/>
    <path d="M10.5 3.7C10.5 3.03726 11.0373 2.5 11.7 2.5H16.3C16.9627 2.5 17.5 3.03726 17.5 3.7V8.3C17.5 8.96274 16.9627 9.5 16.3 9.5H11.7C11.0373 9.5 10.5 8.96274 10.5 8.3V3.7Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_6084_34">
    <rect width="15" height="15" fill="currentColor" transform="translate(2.5 2.5)"/>
    </clipPath>
    </defs>
    </svg>
  )
}

function WorkflowIcon(){
  return (
      <svg width="20" height="20" viewBox="0 0 20 20" >
      <g clipPath="url(#clip0_4096_2109)">
      <path d="M2.5 3.7C2.5 3.03726 3.03726 2.5 3.7 2.5H16.3C16.9627 2.5 17.5 3.03726 17.5 3.7V8.3C17.5 8.96274 16.9627 9.5 16.3 9.5H3.7C3.03726 9.5 2.5 8.96274 2.5 8.3V3.7Z" fill="currentColor"/>
      <path d="M2.5 11.7C2.5 11.0373 3.03726 10.5 3.7 10.5H16.3C16.9627 10.5 17.5 11.0373 17.5 11.7V16.3C17.5 16.9627 16.9627 17.5 16.3 17.5H3.7C3.03726 17.5 2.5 16.9627 2.5 16.3V11.7Z" fill="currentColor"/>
      </g>
      <defs>
      <clipPath id="clip0_4096_2109">
      <rect width="15" height="15" fill="currentColor" transform="translate(2.5 2.5)"/>
      </clipPath>
      </defs>
    </svg>
  )
}


function DashboardIcon(){
  return(
  <svg width="20" height="20" viewBox="0 0 20 20" >
  <g clipPath="url(#clip0_4096_2115)">
  <path d="M2.5 3.7C2.5 3.03726 3.03726 2.5 3.7 2.5H8.3C8.96274 2.5 9.5 3.03726 9.5 3.7V10.3C9.5 10.9627 8.96274 11.5 8.3 11.5H3.7C3.03726 11.5 2.5 10.9627 2.5 10.3V3.7Z" fill="currentColor"/>
  <path d="M2.5 13.7C2.5 13.0373 3.03726 12.5 3.7 12.5H8.3C8.96274 12.5 9.5 13.0373 9.5 13.7V16.3C9.5 16.9627 8.96274 17.5 8.3 17.5H3.7C3.03726 17.5 2.5 16.9627 2.5 16.3V13.7Z" fill="currentColor"/>
  <path d="M10.5 3.7C10.5 3.03726 11.0373 2.5 11.7 2.5H16.3C16.9627 2.5 17.5 3.03726 17.5 3.7V5.3C17.5 5.96274 16.9627 6.5 16.3 6.5H11.7C11.0373 6.5 10.5 5.96274 10.5 5.3V3.7Z" fill="currentColor"/>
  <path d="M10.5 8.7C10.5 8.03726 11.0373 7.5 11.7 7.5H16.3C16.9627 7.5 17.5 8.03726 17.5 8.7V16.3C17.5 16.9627 16.9627 17.5 16.3 17.5H11.7C11.0373 17.5 10.5 16.9627 10.5 16.3V8.7Z" fill="currentColor"/>
  </g>
  <defs>
  <clipPath id="clip0_4096_2115">
  <rect width="15" height="15" fill="currentColor" transform="translate(2.5 2.5)"/>
  </clipPath>
  </defs>
  </svg>
  )
}

function CustomerCareIcon(){
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" >
      <g clipPath="url(#clip0_4096_2141)">
      <g opacity="0.987">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.1875 1C7.64453 1 8.10156 1 8.5586 1C10.9298 1.30915 12.717 2.49274 13.9199 4.55078C14.8775 6.42806 15.0064 8.36165 14.3067 10.3516C13.6121 12.1008 12.4109 13.3722 10.7031 14.166C9.01893 14.8595 7.30798 14.9298 5.57031 14.377C5.1541 14.2186 4.7498 14.0369 4.35742 13.8321C3.23541 14.1286 2.11627 14.4333 1 14.7461C1 14.7226 1 14.6992 1 14.6758C1.32023 13.5945 1.62492 12.5047 1.91406 11.4062C1.67181 10.9436 1.46673 10.4632 1.29883 9.96484C1.16916 9.50943 1.06955 9.0524 1 8.59374C1 8.11326 1 7.63282 1 7.15234C1.46398 4.15112 3.13976 2.17651 6.02734 1.22852C6.4149 1.13106 6.80163 1.05489 7.1875 1ZM7.85547 4.16406C9.02273 4.25914 9.72002 4.88024 9.94726 6.02734C10.0095 6.6373 9.84545 7.17635 9.45508 7.64453C9.10352 7.97265 8.75195 8.30079 8.40039 8.6289C8.38281 8.90991 8.37698 9.19116 8.38281 9.47266C8.04296 9.47266 7.70314 9.47266 7.36328 9.47266C7.35741 9.0389 7.36328 8.60531 7.38086 8.17187C7.84844 7.76294 8.30547 7.34106 8.75195 6.90624C9.09342 6.28599 8.98209 5.76452 8.41797 5.34179C7.71045 5.04522 7.18894 5.23858 6.85352 5.92187C6.81684 6.03638 6.79926 6.15356 6.80078 6.27344C6.46092 6.27344 6.12111 6.27344 5.78124 6.27344C5.90739 5.01059 6.5988 4.30748 7.85547 4.16406ZM7.36328 10.5273C7.70314 10.5273 8.04296 10.5273 8.38281 10.5273C8.38281 10.8789 8.38281 11.2305 8.38281 11.582C8.04296 11.582 7.70314 11.582 7.36328 11.582C7.36328 11.2305 7.36328 10.8789 7.36328 10.5273Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M19 12.5312C19 12.9648 19 13.3984 19 13.8321C18.8872 14.6566 18.6294 15.4359 18.2266 16.1699C18.4716 17.0978 18.7294 18.0177 19 18.9297C19 18.9531 19 18.9766 19 19C18.9766 19 18.9531 19 18.9297 19C18.0177 18.7294 17.0978 18.4716 16.1699 18.2266C15.4359 18.6294 14.6566 18.8872 13.8321 19C13.3984 19 12.9648 19 12.5312 19C10.4724 18.6972 8.94897 17.6308 7.96094 15.8008C11.2724 15.5982 13.6572 14.0163 15.1152 11.0547C15.5343 10.0667 15.7629 9.03542 15.8008 7.96094C17.6308 8.94897 18.6972 10.4724 19 12.5312Z" fill="currentColor"/>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_4096_2141">
      <rect width="18" height="18" fill="currentColor" transform="translate(1 1)"/>
      </clipPath>
      </defs>
    </svg>
  )
}

function CdkUIcon() {
  return (
      <svg width="20" height="20" viewBox="0 0 20 20" >
      <path fillRule="evenodd" clipRule="evenodd" d="M3.63438 1.6C4.68438 1.6 5.73438 1.6 6.78438 1.6C6.7789 4.54221 6.78438 7.48439 6.80079 10.4266C6.86464 11.8075 7.55918 12.6879 8.88438 13.0679C9.58437 13.1774 10.2844 13.1774 10.9844 13.0679C12.3096 12.6879 13.0041 11.8075 13.0679 10.4266C13.0844 7.48439 13.0899 4.54221 13.0844 1.6C14.1782 1.6 15.2718 1.6 16.3656 1.6C16.3712 4.58596 16.3656 7.57191 16.3492 10.5578C16.2208 12.7793 15.2091 14.4582 13.314 15.5945C12.2726 16.1482 11.1625 16.3834 9.9836 16.3C7.7177 16.3919 5.92394 15.5278 4.60234 13.7078C4.07708 12.8977 3.75988 12.0118 3.65078 11.05C3.63438 7.90004 3.6289 4.75002 3.63438 1.6Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.2344 18.4C12.0344 18.4 7.8344 18.4 3.6344 18.4C3.6344 18.05 3.6344 17.7 3.6344 17.35C7.8344 17.35 12.0344 17.35 16.2344 17.35C16.2344 17.7 16.2344 18.05 16.2344 18.4Z" fill="currentColor"/>
      </svg>
  );
}

function ResourceCenterIcon() {
  return (
    <svg width="16.67" height="20" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 18C6.5 17.0512 5.35417 16.3256 4.0625 15.8233C2.77083 15.3209 1.41667 15.0698 0 15.0698V5.86046C1.40278 5.86046 2.75 6.11512 4.04167 6.62442C5.33333 7.13372 6.48611 7.86977 7.5 8.83256C8.51389 7.86977 9.66667 7.13372 10.9583 6.62442C12.25 6.11512 13.5972 5.86046 15 5.86046V15.0698C13.5694 15.0698 12.2118 15.3209 10.9271 15.8233C9.64236 16.3256 8.5 17.0512 7.5 18Z
           M7.5 15.8233C8.375 15.1674 9.30556 14.6442 10.2917 14.2535C11.2778 13.8628 12.2917 13.6047 13.3333 13.4791V7.70233C12.3194 7.88372 11.3229 8.25 10.3438 8.80116C9.36458 9.35233 8.41667 10.0884 7.5 11.0093C6.58333 10.0884 5.63542 9.35233 4.65625 8.80116C3.67708 8.25 2.68056 7.88372 1.66667 7.70233V13.4791C2.70833 13.6047 3.72222 13.8628 4.70833 14.2535C5.69444 14.6442 6.625 15.1674 7.5 15.8233Z
           M5.14583 5.71395C4.49306 5.05814 4.16667 4.26977 4.16667 3.34884C4.16667 2.42791 4.49306 1.63953 5.14583 0.983721C5.79861 0.327907 6.58333 0 7.5 0C8.41667 0 9.20139 0.327907 9.85417 0.983721C10.5069 1.63953 10.8333 2.42791 10.8333 3.34884C10.8333 4.26977 10.5069 5.05814 9.85417 5.71395C9.20139 6.36977 8.41667 6.69767 7.5 6.69767C6.58333 6.69767 5.79861 6.36977 5.14583 5.71395Z
           M8.67708 4.5314C9.00347 4.20349 9.16667 3.8093 9.16667 3.34884C9.16667 2.88837 9.00347 2.49419 8.67708 2.16628C8.35069 1.83837 7.95833 1.67442 7.5 1.67442C7.04167 1.67442 6.64931 1.83837 6.32292 2.16628C5.99653 2.49419 5.83333 2.88837 5.83333 3.34884C5.83333 3.8093 5.99653 4.20349 6.32292 4.5314C6.64931 4.8593 7.04167 5.02326 7.5 5.02326C7.95833 5.02326 8.35069 4.8593 8.67708 4.5314Z"
        fill="currentColor"
      />
    </svg>
  );
}

function AppsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4096_2101)">
      <path d="M2.5 3.7C2.5 3.03726 3.03726 2.5 3.7 2.5H8.3C8.96274 2.5 9.5 3.03726 9.5 3.7V8.3C9.5 8.96274 8.96274 9.5 8.3 9.5H3.7C3.03726 9.5 2.5 8.96274 2.5 8.3V3.7Z" fill="currentColor"/>
      <path d="M2.5 11.7C2.5 11.0373 3.03726 10.5 3.7 10.5H8.3C8.96274 10.5 9.5 11.0373 9.5 11.7V16.3C9.5 16.9627 8.96274 17.5 8.3 17.5H3.7C3.03726 17.5 2.5 16.9627 2.5 16.3V11.7Z" fill="currentColor"/>
      <path d="M10.5 3.7C10.5 3.03726 11.0373 2.5 11.7 2.5H16.3C16.9627 2.5 17.5 3.03726 17.5 3.7V8.3C17.5 8.96274 16.9627 9.5 16.3 9.5H11.7C11.0373 9.5 10.5 8.96274 10.5 8.3V3.7Z" fill="currentColor"/>
      <path d="M10.5 11.7C10.5 11.0373 11.0373 10.5 11.7 10.5H16.3C16.9627 10.5 17.5 11.0373 17.5 11.7V16.3C17.5 16.9627 16.9627 17.5 16.3 17.5H11.7C11.0373 17.5 10.5 16.9627 10.5 16.3V11.7Z" fill="currentColor"/>
      </g>
      <defs>
      <clipPath id="clip0_4096_2101">
      <rect width="15" height="15" fill="currentColor" transform="translate(2.5 2.5)"/>
      </clipPath>
      </defs>
    </svg>
  );
}
function AivaIcon() {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="currentColor" >
      <path d="M9.1156 0.143486C9.61211 -0.0706728 10.2045 -0.0624435 10.7363 0.286689C11.1898 0.584457 11.4969 1.0644 11.7242 1.57711C12.1569 2.55324 12.5902 4.19357 12.9717 5.80139C13.2797 7.09902 13.5796 8.49128 13.8234 9.5897C15.8783 9.81138 17.8558 9.95206 19.7921 10.1743C20.6292 10.2704 21.586 10.5924 21.9075 11.5373C22.0536 11.9668 22.0046 12.3784 21.9118 12.6964C21.8191 13.0142 21.6643 13.3047 21.5066 13.5495C20.9031 14.4857 19.8437 15.3653 19.6129 15.5551C19.0053 16.0549 18.3776 16.5644 17.7595 16.9269C17.1381 17.2913 16.3892 17.5912 15.5502 17.4992C14.8244 17.4195 14.3259 16.8931 14.0378 16.5184C13.7095 16.0914 13.4167 15.5446 13.1589 14.9628C12.727 13.988 12.3371 12.7853 12.0247 11.5659C11.0144 11.435 9.98185 11.2772 8.93408 11.0775C8.92981 11.2161 8.92561 11.3548 8.9213 11.4935C8.88373 12.7029 8.84227 13.9143 8.75833 15.0005C8.67537 16.074 8.54661 17.0929 8.31339 17.8964C8.19682 18.298 8.03854 18.7024 7.80794 19.0465C7.57496 19.3943 7.21873 19.751 6.69432 19.9063C6.03079 20.1028 5.40681 19.9623 4.92128 19.743C4.44087 19.5261 4.01915 19.2 3.67991 18.8863C3.00122 18.2588 2.47853 17.5173 2.27679 17.1987C1.44544 15.8858 0.829014 14.6563 0.44956 13.5762C0.0814343 12.5282 -0.109116 11.4946 0.0653977 10.6334C0.197489 9.98154 0.503995 9.41455 1.04564 8.99167C1.55196 8.59639 2.17341 8.3993 2.80133 8.28309C3.16199 8.21634 3.62909 8.22162 4.05533 8.24274C4.51163 8.26536 5.0341 8.31339 5.5577 8.37148C5.98039 8.41838 6.41247 8.47291 6.82273 8.52782C6.8345 8.28021 6.84717 8.03487 6.86159 7.79296C6.97324 5.91954 7.1254 4.54888 7.27332 3.58898C7.41443 2.67321 7.56446 2.03997 7.70938 1.71301L7.71073 1.70996C7.8242 1.4561 7.98558 1.16455 8.19211 0.897856C8.38637 0.647005 8.69028 0.32695 9.1156 0.143486ZM3.94481 10.4144C3.52262 10.3935 3.2874 10.4055 3.20741 10.4203C2.73381 10.5079 2.51527 10.6167 2.41232 10.6971C2.34473 10.7499 2.27259 10.8284 2.22569 11.0598C2.16612 11.3538 2.20811 11.9444 2.53106 12.8637C2.84268 13.7508 3.37591 14.8317 4.14502 16.0463C4.2875 16.2713 4.69437 16.8448 5.18604 17.2994C5.43193 17.5268 5.65561 17.6834 5.83778 17.7657C5.90281 17.795 5.95273 17.8104 5.98838 17.8181C6.04507 17.7241 6.1195 17.5596 6.19559 17.2974C6.36468 16.7149 6.48119 15.8774 6.56174 14.8351C6.64131 13.8054 6.6816 12.6415 6.71933 11.4269C6.72668 11.1901 6.73393 10.9513 6.74138 10.7116C6.28188 10.6487 5.78916 10.5854 5.31149 10.5324C4.80934 10.4767 4.337 10.4338 3.94481 10.4144ZM14.3788 11.8341C14.6216 12.6724 14.8946 13.4532 15.1774 14.0914C15.4024 14.5993 15.6137 14.9712 15.7927 15.2039C15.8415 15.2675 15.8803 15.3105 15.9082 15.3389C16.0638 15.3267 16.2911 15.2587 16.6341 15.0576C17.0762 14.7983 17.5708 14.4041 18.2024 13.8846C18.4535 13.678 19.2529 12.9947 19.6477 12.3822C19.6544 12.3719 19.6606 12.3618 19.6667 12.352C19.6283 12.3459 19.5855 12.3398 19.5377 12.3343C17.9482 12.1519 16.2129 12.0192 14.3788 11.8341ZM9.72741 2.5851C9.72406 2.59483 9.69002 2.68927 9.63692 2.9173C9.5832 3.14798 9.51902 3.47602 9.45122 3.916C9.31572 4.79533 9.16953 6.09751 9.06087 7.92064C9.04222 8.23357 9.02625 8.5527 9.01193 8.87634C9.85775 9.04528 10.688 9.18403 11.5048 9.30144C11.2986 8.36426 11.071 7.32709 10.8267 6.29723C10.4527 4.72144 10.0756 3.32795 9.74664 2.54356C9.73997 2.55757 9.73354 2.57144 9.72741 2.5851Z" fill="currentColor"/>
    </svg>
  );
}
